
import { RevModal } from '@ds/components/Modal'
import { IconBadge } from '@ds/icons/IconBadge'
import { IconMoney } from '@ds/icons/IconMoney'
import { IconPackage } from '@ds/icons/IconPackage'
import { IconShoppingBag } from '@ds/icons/IconShoppingBag'

import { MODAL_NAMES } from '@config/constants'

import ContentRow from '../../../ContentRow'

import translations from './TradeInModal.translations'

export default {
  components: {
    RevModal,
    ContentRow,
    IconShoppingBag,
    IconBadge,
    IconPackage,
    IconMoney,
  },
  computed: {
    modalName: () => MODAL_NAMES.PRODUCT.TRADE_IN,
    translations: () => translations,
  },
}
